import { useEffect, useState } from "react";
import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import AuthService from "../../services/authService";
import { NavLink } from "react-router-dom";
import { Button } from "react-bootstrap";
import ReactPaginate from "react-paginate";

import "./shiftCashPost.css";
import shiftService from "../../services/shiftCashService";
import AvailableForCheckoutShiftComponent from "./availableForCheckoutShift";
import AvailableForDepositShiftComponent from "./availableForDepositShift";
import Modal from "../modal";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { actionCreators, State } from "../../state/index";
import { bindActionCreators } from "redux";
// Redux end.
import {
  IAvailableForCheckoutShift,
  IAvailableForDepositShift,
  IAvailableForCheckoutShifts,
  IAvailableForDepositShifts,
  IEmployee,
  IProps,
} from "./interface";

function ShiftCashPost(props: IProps) {
  const [availableForCheckoutShifts, setAvailableForCheckoutShifts] =
    useState<IAvailableForCheckoutShifts>({ data: [] });
  const [availableForDepositShifts, setAvailableForDepositShifts] =
    useState<IAvailableForDepositShifts>({ cashes: [], isSaving: false });
  const [totalCash, setTotalCash] = useState(0);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [currentPage, setCurrentPage] = useState(1);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [perPage, setPerPage] = useState(5);
  const [pageCount, setPageCount] = useState(0);
  const [offset, setOffset] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [isFetchFailed, setIsFetchFailed] = useState(false);
  const [showFetchFailedModal, setShowFetchFailedModal] = useState(false);
  const [
    isLoadingForAvailableForCheckout,
    setIsLoadingForAvailableForCheckout,
  ] = useState(true);
  const [isLoadingForAvailableForDeposit, setIsLoadingForAvailableForDeposit] =
    useState(true);
  const [languageData, setLanguageData] = useState<any>();
  const [isPostDepositFailed, setIsPostDepositFailed] = useState(false);

  const [
    isLoadingLoadShiftAvailableForCheckoutButton,
    setIsLoadingLoadShiftAvailableForCheckoutButton,
  ] = useState(false);
  const [
    isLoadingLoadShiftAvailableForDepositButton,
    setIsLoadingLoadShiftAvailableForDepositButton,
  ] = useState(false);
  const [failResponseMessage, setFailResponseMessage] = useState<any>();
  const { history } = props ?? {};

  // Redux
  const dispatch = useDispatch();
  const { logout } = bindActionCreators(actionCreators.authActions, dispatch);
  const state = useSelector((state: State) => state);
  const { isLoggedIn } = state.authReducer;
  const stateLanguage = state.languageReducer;
  useEffect(() => {
    console.log(props);
    if (!isLoggedIn) {
      history.push("/login");
    }
  }, []);

  useEffect(() => {
    fetchAvailableForDepositShifts();
    fetchAvailableForCheckoutShifts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setLanguageData(stateLanguage);
  }, [stateLanguage]);

  const toggleShowModal = () => {
    setShowModal(!showModal);
  };

  const toggleShowFetchFailedModal = () => {
    setShowFetchFailedModal(!showFetchFailedModal);
  };

  const toggleShowDepositPostFailedModal = () => {
    setIsPostDepositFailed(!isPostDepositFailed);
  };

  const fetchAvailableForCheckoutShifts = async () => {
    try {
      const response: any = await shiftService.getAvailableForCheckoutShifts();
      if (response) {
        setIsLoadingForAvailableForCheckout(false);
        setIsFetchFailed(false);
        const { data } = response ?? {};
        const data2 = data.map((el: any) => {
          return {
            ...el,
            inputHidden: true,
            isSaving: false,
            isPostFailed: false,
            isSaved: false,
          };
        });
        setIsLoadingLoadShiftAvailableForCheckoutButton(false);
        setAvailableForCheckoutShifts({ data: [...data2] });
        setPageCount(Math.ceil(data.length / perPage));
      }
    } catch (e: any) {
      console.dir(e);
      if (e.response) {
        if (e.response.status === 401) {
          const { dispatch, history } = props ?? {};
          if (isLoggedIn) {
            dispatch(logout());
          }
          history.push("/login");
        }

        if (e.response.status === 423) {
          setFailResponseMessage(e.response.data);
        }

        if (e.response.status === 403) {
          setFailResponseMessage({ message: e.response.data.error });
        }
      }

      if (!e.response) {
        setIsFetchFailed(true);
        setShowFetchFailedModal(true);
      }
      setIsLoadingForAvailableForCheckout(false);
    }
  };
  const fetchAvailableForDepositShifts = async () => {
    try {
      const response: any = await shiftService.getAvailableForDepositShifts();
      if (response) {
        setIsLoadingForAvailableForDeposit(false);
        setIsFetchFailed(false);
        setAvailableForDepositShifts({
          cashes: response.data,
          isSaving: false,
        });
        setIsLoadingLoadShiftAvailableForDepositButton(false);
      }
    } catch (e: any) {
      console.dir(e);
      if (e.response) {
        if (e.response.status === 401) {
          const { dispatch, history } = props ?? {};
          if (isLoggedIn) {
            dispatch(logout());
          }
          history.push("/login");
        }

        if (e.response.status === 423) {
          setFailResponseMessage(e.response.data);
        }

        if (e.response.status === 403) {
          setFailResponseMessage({ message: e.response.data.error });
        }
      }

      if (!e.response) {
        setIsFetchFailed(true);
        setShowFetchFailedModal(true);
      }
      setIsLoadingForAvailableForDeposit(false);
      setIsLoadingLoadShiftAvailableForDepositButton(false);
      setIsLoadingLoadShiftAvailableForCheckoutButton(false);
    }
  };

  // useEffect(()=>{

  // },[availableForDepositShifts])

  const retryFetch = () => {
    if (showFetchFailedModal) {
      setShowFetchFailedModal(false);
    }
    setIsLoadingForAvailableForCheckout(true);
    setIsLoadingForAvailableForDeposit(true);
    fetchAvailableForCheckoutShifts();
    fetchAvailableForDepositShifts();
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars

  const onToggleButtonClick = (shiftId: number) => {
    const updatedShifts = availableForCheckoutShifts.data.map((el: any) => {
      if (shiftId === el.shiftId) {
        return { ...el, inputHidden: !el.inputHidden };
      }
      return el;
    });
    // console.log(updatedShifts);
    setAvailableForCheckoutShifts({ data: [...updatedShifts] });
    // console.log(inputHidden);
  };

  const saveAvailableForCheckoutShift = (shift: IAvailableForCheckoutShift) => {
    console.log("shift", shift);
    setIsLoadingForAvailableForDeposit(true);
    const changeSaving = availableForCheckoutShifts.data.map(
      (theShift: IAvailableForCheckoutShift) => {
        if (theShift.shiftId === shift.shiftId) {
          shift.isSaving = true;
          shift.isPostFailed = false;
          return shift;
        }
        return theShift;
      }
    );

    setAvailableForCheckoutShifts({ data: [...changeSaving] });

    let postShiftArr: any = {
      shiftsEntityId: shift.shiftsEntityId,
      employees: [],
    };

    shift.employees.forEach((employee: IEmployee) => {
      postShiftArr.employees.push({
        shiftCashEntityId: employee.shiftCashEntityId,
        amount: employee.amount,
        note: employee.note,
        employeeName: employee.employeeName,
      });
    });

    shiftService
      .postAvailableForCheckoutToDepositCashes(postShiftArr)
      .then((response) => {
        const updatedShifts = availableForCheckoutShifts.data.filter(
          (theShift: IAvailableForCheckoutShift) => {
            if (theShift.shiftId === shift.shiftId) {
              return false;
            }
            return true;
          }
        );

        console.log(updatedShifts);

        setAvailableForCheckoutShifts({ data: [...updatedShifts] });
        console.log(availableForCheckoutShifts);
        fetchAvailableForDepositShifts();
      })
      .catch((err) => {
        console.dir(err);
        const updatedShifts = availableForCheckoutShifts.data.map(
          (theShift: IAvailableForCheckoutShift) => {
            if (theShift.shiftId === shift.shiftId) {
              shift.isPostFailed = true;
              shift.isSaving = false;
              shift.postFailedMessage = err.response.data.message;
              return shift;
            }
            return theShift;
          }
        );
        console.log("updatedShifts", updatedShifts);
        setAvailableForCheckoutShifts({ data: [...updatedShifts] });
      });
  };

  const handleNoteInputChange = (
    shiftId: number,
    employeeName: string,
    element: any
  ) => {
    const note = element.target.value;
    const updatedShifts = availableForCheckoutShifts.data.map(
      (shift: IAvailableForCheckoutShift) => {
        if (shiftId === shift.shiftId) {
          const employees = shift.employees.map((employee: IEmployee) => {
            if (employee.employeeName === employeeName) {
              employee.note = note;
              return employee;
            }
            return employee;
          });
          shift.employees = employees;
          return shift;
        }
        return shift;
      }
    );
    setAvailableForCheckoutShifts({ data: updatedShifts });
  };

  const handleCashInputChange = (
    shiftId: number,
    employeeName: string,
    element: any
  ) => {
    let cash = element.target.value;
    if (cash === "") cash = 0;
    // console.log(shiftId, employeeName, cash);
    if (Number.isNaN(cash)) {
      alert("Please enter a valid number.");
      element.target.value = 0;
    }

    const updatedShifts = availableForCheckoutShifts.data.map(
      (shift: IAvailableForCheckoutShift) => {
        if (shiftId === shift.shiftId) {
          const employees = shift.employees.map((employee: IEmployee) => {
            if (employee.employeeName === employeeName) {
              employee.amount = Number.parseFloat(cash);
              return employee;
            }
            return employee;
          });
          shift.employees = employees;
          // console.log(shift);
          return shift;
        }
        return shift;
      }
    );
    setAvailableForCheckoutShifts({ data: updatedShifts });
  };

  useEffect(() => {
    const calculateTotalCash = () => {
      let totalCash: number = 0;
      availableForDepositShifts.cashes.forEach(
        (shift: IAvailableForDepositShift) => {
          shift.employees.forEach((employee: IEmployee) => {
            totalCash += employee.amount;
          });
        }
      );
      setTotalCash(totalCash);
    };
    calculateTotalCash();
  }, [availableForDepositShifts]);

  const depositCashInBank = () => {
    console.log(availableForDepositShifts);
    setShowModal(false);
    setIsLoadingForAvailableForDeposit(true);
    setIsPostDepositFailed(false);

    if (
      availableForDepositShifts === null ||
      availableForDepositShifts.cashes === null ||
      availableForDepositShifts.cashes.length === 0
    ) {
      alert("There are not shifts to deposit in the bank.");
      return;
    }
    setAvailableForDepositShifts({
      ...availableForDepositShifts,
      isSaving: true,
    });

    console.log(availableForDepositShifts.cashes);
    let postDTO;
    if (
      availableForDepositShifts.cashes &&
      availableForDepositShifts.cashes.length > 0
    ) {
      postDTO = {
        depositEntityId: availableForDepositShifts.cashes[0].depositEntityId,
      };
    }

    shiftService
      .postAvailableForDepositToBankCashes(postDTO)
      .then((response) => {
        setAvailableForDepositShifts({
          ...availableForDepositShifts,
          isSaving: false,
        });
        fetchAvailableForDepositShifts();
        shiftService.getDepositPrint(languageData?.appLanguage);
      })
      .catch((e: any) => {
        setIsPostDepositFailed(true);
        setIsLoadingForAvailableForDeposit(false);
      });
  };

  const handlePageClick = (e: any) => {
    const selectedPage = e.selected;
    console.log(e.selected);
    const offset = selectedPage * perPage;
    console.log(offset);

    setCurrentPage(selectedPage);
    setOffset(offset);
  };

  if (!isLoggedIn) {
    return <Redirect to="/login" />;
  }

  const arrangeAvailableForCheckoutShifts = (
    shifts: IAvailableForCheckoutShifts
  ) => {
    if (shifts.data.length === 0 && !isLoadingForAvailableForCheckout) {
      return (
        <div>
          <h3>{languageData?.data?.shiftCashPost?.noShiftAvailable}</h3>
          <div className={"deposit-button-wrapper"}>
            <Button
              className={"deposit-button"}
              onClick={() => {
                setShowFetchFailedModal(false);
                setIsLoadingLoadShiftAvailableForCheckoutButton(true);
                fetchAvailableForCheckoutShifts();
              }}
            >
              {isLoadingLoadShiftAvailableForCheckoutButton && (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              )}
              {isLoadingLoadShiftAvailableForCheckoutButton
                ? languageData?.data?.shiftCashPost?.loading
                : languageData?.data?.shiftCashPost?.loadShifts}
            </Button>
          </div>
        </div>
      );
    }
    const slice = shifts.data.slice(offset, offset + perPage);
    return slice.map((shift: IAvailableForCheckoutShift, index: number) => {
      console.log("initialized");
      return (
        <AvailableForCheckoutShiftComponent
          key={shift.shiftsEntityId}
          languageData={languageData}
          fetchDeposit={fetchAvailableForDepositShifts}
          onCashInputChange={handleCashInputChange}
          onNoteInputChange={handleNoteInputChange}
          saveButtonClicked={saveAvailableForCheckoutShift}
          toggleButtonClicked={onToggleButtonClick}
          shift={shift}
        />
      );
    });
  };

  const arrangeAvailableForDepositShifts = (
    shifts: IAvailableForDepositShifts
  ) => {
    if (shifts.cashes.length === 0 && !isLoadingForAvailableForDeposit) {
      return (
        <div>
          <h3>{languageData?.data?.shiftCashPost?.noShiftAvailable}</h3>
          <div className={"deposit-button-wrapper"}>
            <Button
              className={"deposit-button"}
              onClick={() => {
                setShowFetchFailedModal(false);
                setIsLoadingLoadShiftAvailableForDepositButton(true);
                fetchAvailableForDepositShifts();
              }}
            >
              {isLoadingLoadShiftAvailableForDepositButton && (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              )}
              {isLoadingLoadShiftAvailableForDepositButton
                ? languageData?.data?.shiftCashPost?.loading
                : languageData?.data?.shiftCashPost?.loadShifts}
            </Button>
          </div>
        </div>
      );
    }
    return shifts.cashes.map(
      (shift: IAvailableForDepositShift, index: number) => {
        return (
          <AvailableForDepositShiftComponent
            key={index + "AvailableForDepositShiftComponent"}
            shift={shift}
            languageData={languageData}
          />
        );
      }
    );
  };

  let useAvailableShiftForDepositComponents: any;
  if (availableForDepositShifts) {
    useAvailableShiftForDepositComponents = arrangeAvailableForDepositShifts(
      availableForDepositShifts
    );
  }

  let useAvailableForCheckoutShiftsComponents: any = null;
  if (availableForCheckoutShifts) {
    useAvailableForCheckoutShiftsComponents = arrangeAvailableForCheckoutShifts(
      availableForCheckoutShifts
    );
  }

  const spinner = (
    <div>
      <div className="d-flex justify-content-center ">
        <div className="spinner-border spinner" role="status"></div>
      </div>
      <div
        style={{ marginTop: "1.5%" }}
        className="d-flex justify-content-center"
      >
        <p style={{ fontStyle: "oblique" }}>Loading...</p>
      </div>
    </div>
  );

  return (
    <div>
      {failResponseMessage && (
        <div>
          <h1>{failResponseMessage.message}</h1>
          {failResponseMessage.details &&
            failResponseMessage.details.map((detail: any) => {
              return <h4>{detail}</h4>;
            })}
        </div>
      )}
      {!failResponseMessage && (
        <div>
          <h1>
            {languageData?.data?.shiftCashPost?.shiftsAvailableForCheckoutH1}
          </h1>

          <div className={"pagination-wrapper"}>
            {isLoadingForAvailableForCheckout && spinner}
            {useAvailableForCheckoutShiftsComponents}
            <ReactPaginate
              previousLabel={languageData?.data?.general?.pagination?.prev}
              nextLabel={languageData?.data?.general?.pagination?.next}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-center"}
              activeClassName={"active"}
            />
          </div>
          {/* <BasicPagination handlePageClick={handlePageClick} /> */}
          <br />
          <h1>
            {languageData?.data?.shiftCashPost?.shiftsAvailableForDepositH1}
          </h1>
          {isLoadingForAvailableForDeposit
            ? spinner
            : useAvailableShiftForDepositComponents}
          <h2>
            {languageData?.data?.shiftCashPost?.totalCashNotice}
            {totalCash} &#8378;
          </h2>
          <div className={"deposit-button-wrapper"}>
            <Button
              className={"deposit-button"}
              disabled={
                isLoadingForAvailableForDeposit ||
                availableForDepositShifts.cashes.length === 0
                  ? true
                  : false
              }
              onClick={toggleShowModal}
            >
              {isLoadingForAvailableForDeposit && (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              )}
              {isLoadingForAvailableForDeposit
                ? languageData?.data?.shiftCashPost?.loading
                : languageData?.data?.shiftCashPost?.depositToBankButton}
            </Button>
          </div>
          <div className={"deposit-button-wrapper"}>
            <Button
              className={"deposit-button"}
              onClick={() =>
                shiftService.getDepositPrint(languageData?.appLanguage)
              }
            >
              {languageData?.data?.shiftCashPost?.printDepositButton}
            </Button>
          </div>
        </div>
      )}

      <Modal
        show={isPostDepositFailed}
        handleClose={toggleShowDepositPostFailedModal}
        onTrue={depositCashInBank}
        buttonText={
          languageData?.data?.shiftCashPost?.depositPostFailedModal?.buttonText
        }
        question={
          languageData?.data?.shiftCashPost?.depositPostFailedModal
            ?.questionText
        }
        totalCash={totalCash}
      ></Modal>
      <Modal
        show={showModal}
        handleClose={toggleShowModal}
        onTrue={depositCashInBank}
        buttonText={languageData?.data?.shiftCashPost?.checkModal?.buttonText}
        question={languageData?.data?.shiftCashPost?.checkModal?.questionText}
        totalCash={totalCash}
      ></Modal>
      <Modal
        show={showFetchFailedModal}
        handleClose={toggleShowFetchFailedModal}
        onTrue={retryFetch}
        buttonText={languageData?.data?.shiftCashPost?.failedModal?.buttonText}
        question={languageData?.data?.shiftCashPost?.failedModal?.questionText}
      />
    </div>
  );
}

// function mapStateToProps(state: any) {
//   // console.log(state);
//   const { isLoggedIn } = state.authReducer ?? {};
//   const { message } = state.messageReducer ?? {};
//   const { user } = state.user ?? {};
//   const { ...language } = state.languageReducer ?? {};
//   return {
//     isLoggedIn,
//     message,
//     user,
//     language,
//   };
// }

// function mapDispatchToProps(dispatch: any): any {
//   return {
//     logout: () => dispatch({ type: "LOGOUT" }),
//   };
// }

// export default connect(mapStateToProps)(ShiftCashPost);
export default ShiftCashPost;
